import React from 'react';
import PrimaryBtn from '../../../../components/buttons/primaryBtn';
import './style.scss';

const HeroSection = ({openModal}) => {
    return (
        <div className='hero__section__main'>
            <div className='custom__container hero__content__section'>
                <h1>
                    The Flex Workspace Industry’s
                    <br />
                    First-Ever Quality Standardization
                </h1>
                <p>
                    Empower Operators to Showcase Their Excellence While Streamlining Occupiers' Workspace Selection Through Standardized Quality Metrics
                </p>
                <div className='btn__section'>
                    <PrimaryBtn onClick={openModal} text={"Apply to Join FlexGrade Global Quality Program"} />
                </div>
            </div>
        </div>
    )
}

export default HeroSection